// @flow
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import type { InputType } from './InputType';
import { t } from '../../../../javascripts/utils/withTranslation';
import Icon from '../../../_particles/icon/react/Icon';

const Input: React$AbstractComponent<
  InputType,
  HTMLInputElement | HTMLTextAreaElement,
> = forwardRef<InputType, HTMLInputElement | HTMLTextAreaElement>(
  (props: InputType, ref) => {
    const {
      type = 'text',
      invalid,
      descriptionId,
      labelId,
      errorId,
      classNames,
      name,
      id,
      onClear,
      clearLabel,
      ...rest
    } = props;

    const attributes = {
      'aria-invalid': invalid && 'true',
      'aria-describedby': descriptionId,
      'aria-labelledby': labelId,
      'aria-errormessage': errorId,
      type,
      name,
      id: id || name,
    };
    const textarea = 'textarea';
    const inputClassNames = classnames(
      'input',
      type === textarea && textarea,
      !onClear && classNames,
      onClear && 'input--clearable',
    );

    const inputWrapClassNames = classnames(
      'input__wrap',
      onClear && classNames,
    );
    const HtmlTag = type === textarea ? textarea : 'input';

    if (onClear) {
      return (
        <div className={inputWrapClassNames}>
          <HtmlTag
            {...rest}
            className={inputClassNames}
            {...attributes}
            ref={ref}
          />

          {Boolean(rest.value) && (
            <button
              className="input__clear"
              type="button"
              aria-label={clearLabel || t('Eingabe löschen')}
              onClick={onClear}
            >
              <Icon icon="bw-cross-large-line" />
            </button>
          )}
        </div>
      );
    }

    return (
      <HtmlTag
        {...rest}
        className={inputClassNames}
        {...attributes}
        ref={ref}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
